import React, { useEffect, useState } from "react";
import api from "../../apis/EdisonApi";
import { toast } from "react-toastify";
import Loader from "../common/Loader";

const TodayStats = () => {
	const [status, setStatus] = useState(null);

	useEffect(() => {
		const controller = new AbortController();
		const now = new Date();

		api.get("/home/today-stats", {
			params: {
				requestedAt: now.toISOString(),
				timezoneOffset: -now.getTimezoneOffset() / 60,
			},
			signal: controller.signal,
		})
			.then((response) => setStatus(response.data))
			.catch((error) => {
				if (error.name !== "CanceledError") {
					toast.error("API error getting today stats");
				}
			});

		return () => controller.abort();
	}, []);

	const stats = [
		{ label: "Today's production", value: status?.todayP },
		{ label: "Today's consumption", value: status?.todayC },
		{ label: "Today's self-consumption", value: status?.todayS },
	];

	return (
		<section className="today-stats-grid" aria-label="Today's energy totals">
			{stats.map(({ label, value }) => (
				<article className="tile-stats" key={label}>
					<h3>{label}</h3>
					{status ? (
						<div className="count">{value ?? "NA"}<small>kWh</small></div>
					) : (
						<Loader size={30} />
					)}
				</article>
			))}
		</section>
	);
};

export default TodayStats;
